export default "__VITE_ASSET__B$YRi515__"